<template>
    <div class="select">
        <div class="header">
            <div class="title">{{ $t('components.select.title') }}</div>
        </div>
        <div class="item">
            <el-card shadow="hover" class="box-card box-card1">
                <img class="logo" src="@/assets/logo22.png" alt="">
                <div class="title">{{ $t('components.select.federatedTraining.title') }}</div>
                <img class="img" src="@/assets/icon1.png" alt="">
                <div class="btn" @click="gotoHome">{{ $t('components.select.federatedTraining.enter') }}</div>
            </el-card>
            <el-card shadow="hover" class="box-card box-card2">
                <img class="logo" src="@/assets/logo22.png" alt="">
                <div class="title">{{ $t('components.select.smartMarket.title') }}</div>
                <img class="img" src="@/assets/icon2.png" alt="">
                <div class="btn" @click="gotoSmartMarket">{{ $t('components.select.smartMarket.enter') }}</div>
            </el-card>
        </div>
    </div>
</template>
<script>
import { gotoMarket } from "@/utils/auth";
export default {
    data() {
        return {

        }
    },
    methods: {
        // 跳转至主页
        gotoHome() {
            if(this.$route.query.more){
                this.$router.push({
                    name: 'Index'
                })
            } else {
                this.$router.push({
                    name: 'newhome'
                })
            }
        },
        // 跳转智能超市
        gotoSmartMarket() {
            gotoMarket()
        }
    }
}
</script>
<style lang="scss" scoped>
.select {
    height: 100%;
    overflow: hidden;

    .header {
        margin: 30px 0 40px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        
        .title {
            font-size: 20px;
        }
    }

    .item {
        display: flex;
        justify-content: space-around;
        align-items: center;

        .box-card {
            box-sizing: border-box;
            text-align: center;
            height: 500px;
            width: 40%;
            border-radius: 20px;
            background: linear-gradient(to bottom left, #7DA5D0 0%, #E8F6DC 70%);
            padding: 20px;
            cursor: default;

            .logo {
                width: 240px;
            }

            .title {
                font-size: 44px;
                font-weight: bold;
                margin: 30px 0;
            }

            .img {
                width: 90px;
            }

            .btn {
                width: 252px;
                height: 78px;
                font-size: 24px;
                font-weight: bold;
                border-radius: 30px;
                text-align: center;
                line-height: 78px;
                margin: 40px auto;
                cursor: pointer;
                transition: all 0.3s ease; // 添加过渡效果
                &:hover {
                    transform: scale(1.05); // hover时放大到1.05倍
                    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1); // 可选：添加阴影效果
                }
            }
        }

        .box-card1 {
            color: #004EA1;

            .btn {
                border: 2px solid #004EA1;
            }
        }

        .box-card2 {
            color: #6FB92D;

            .btn {
                border: 2px solid #6FB92D;
            }
        }
    }
}
</style>